<!-- Employees -->
<div class="hero-wrapper">
  <div class="hero-image">
    <img src="assets/common/associations.png" alt="SR Group" />
  </div>

  <oth-hero [contents]="employeeAppHeroContents"></oth-hero>
</div>
<!-- Journey -->
<oth-hero [contents]="journeyContents"></oth-hero>

<!-- Follow Us -->
<oth-hero [contents]="followUsAppHeroContents">
</oth-hero>
<div class="websites-wrapper">
  <ng-container *ngFor="let website of websites">
    <oth-brand-button (click)="redirect(website.url + '/' + website.handle)" [icon]="website.cssClass"
      [text]="website.name">
    </oth-brand-button>
  </ng-container>
</div>

<!-- Contact Information -->
<oth-hero [contents]="contactInformationAppHeroContents">
</oth-hero>
<div class="contact-information-wrapper">
  <app-contact-information-card></app-contact-information-card>
</div>